/* LQK Mix & Match — the noble titles of Saidatina Fatimah (RA).
 * Tap a name, then tap its meaning. Rounds of four pairs keep it phone-sized.
 * Depends on lqk-games-kit.js (window.LQKG).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-mixmatch]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  var PAIRS = JSON.parse(root.getAttribute('data-pairs'));
  var ROUND_SIZE = 4;

  var namesEl = root.querySelector('[data-names]');
  var meaningsEl = root.querySelector('[data-meanings]');
  var matchedEl = root.querySelector('[data-matched]');
  var roundEl = root.querySelector('[data-round]');
  K.soundButton(root.querySelector('[data-sound]'));
  var win = K.modal(root);

  var rounds, roundIx, matchedTotal, selName = null, selMeaning = null, lock = false;

  function start() {
    var shuffled = K.shuffle(PAIRS);
    rounds = [];
    for (var i = 0; i < shuffled.length; i += ROUND_SIZE) rounds.push(shuffled.slice(i, i + ROUND_SIZE));
    roundIx = 0; matchedTotal = 0;
    renderRound();
  }

  function card(text, kind, id) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lqkg-mm__card lqkg-mm__card--' + kind;
    b.setAttribute('data-id', id);
    b.innerHTML = '<span>' + text + '</span>';
    return b;
  }

  function renderRound() {
    var round = rounds[roundIx];
    selName = selMeaning = null; lock = false;
    roundEl.textContent = (roundIx + 1) + '/' + rounds.length;
    matchedEl.textContent = matchedTotal + '/' + PAIRS.length;
    namesEl.innerHTML = ''; meaningsEl.innerHTML = '';
    K.shuffle(round).forEach(function (p, i) { namesEl.appendChild(card(p.name, 'name', p.name)); });
    K.shuffle(round).forEach(function (p) { meaningsEl.appendChild(card(p.description, 'meaning', p.name)); });
  }

  function select(btn, kind) {
    if (lock || btn.classList.contains('is-matched')) return;
    K.sound.tap();
    var prev = kind === 'name' ? selName : selMeaning;
    if (prev) prev.classList.remove('is-selected');
    if (prev === btn) { // deselect
      if (kind === 'name') selName = null; else selMeaning = null;
      return;
    }
    btn.classList.add('is-selected');
    if (kind === 'name') selName = btn; else selMeaning = btn;
    if (selName && selMeaning) judge();
  }

  function judge() {
    lock = true;
    var a = selName, b = selMeaning;
    var hit = a.getAttribute('data-id') === b.getAttribute('data-id');
    setTimeout(function () {
      if (hit) {
        [a, b].forEach(function (el) { el.classList.remove('is-selected'); el.classList.add('is-matched'); });
        matchedTotal++;
        matchedEl.textContent = matchedTotal + '/' + PAIRS.length;
        K.sound.ding(); K.vibrate(30);
        var left = rounds[roundIx].length - namesEl.querySelectorAll('.is-matched').length;
        if (left === 0) {
          if (roundIx + 1 < rounds.length) {
            roundIx++;
            setTimeout(renderRound, 700);
          } else {
            K.confetti(); K.sound.win();
            win.show({
              title: 'Masha Allah!', stars: 3,
              text: 'You matched all ' + PAIRS.length + ' beautiful titles of Saidatina Fatimah (RA)!',
              againLabel: 'Play again', onAgain: start,
            });
          }
        }
      } else {
        [a, b].forEach(function (el) { el.classList.add('is-wrong'); });
        K.sound.buzz();
        setTimeout(function () {
          [a, b].forEach(function (el) { el.classList.remove('is-selected', 'is-wrong'); });
        }, 420);
      }
      selName = selMeaning = null;
      lock = false;
    }, 180);
  }

  namesEl.addEventListener('click', function (e) {
    var b = e.target.closest('.lqkg-mm__card');
    if (b) select(b, 'name');
  });
  meaningsEl.addEventListener('click', function (e) {
    var b = e.target.closest('.lqkg-mm__card');
    if (b) select(b, 'meaning');
  });

  start();
})();
